import { Box, Typography, Tooltip } from '@mui/material';
import { TagType } from 'src/features/sites/types/types';
import { TagResponse } from 'src/types';

type Props = {
  label: string;
  liveDataComplete: any;
  id: string;
  restTags: TagResponse[];
};

export const LabelAndValue = ({ label, liveDataComplete, id, restTags }: Props) => {
  const liveDataTag = liveDataComplete?.tags?.find((item: TagType) => item.id === id);
  const restTag = restTags?.find((tag) => tag.id === id);

  const tagValue = Number(liveDataTag?.value || restTag?.value);

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title={tagValue} placement="top-end">
        <Typography sx={{ fontSize: '13px' }}>
          {label}: {tagValue}
        </Typography>
      </Tooltip>
    </Box>
  );
};
